import Vue from 'vue'
import * as core from '@/core'
import Antd from 'ant-design-vue'
import filters from '../assets/js/filters'
import mixin from '@/assets/js/mixin'
import '@/assets/less/antd.less'
import AdminTk from '@moke/admin-tk'
import viewPage from '@/core/component/viewPage'
import '@moke/admin-tk/dist/ak.css'
Vue.use(AdminTk, core)
// 全局引入antd
Vue.use(Antd)
// 注册查看组件
Vue.component('viewPage', viewPage)
// 全局filter
for (let name in filters) {
  Vue.filter(name, filters[name])
}
// mixin
Vue.mixin(mixin)

// 同时监听多个属性
Vue.prototype.$watchAll = function (props, callback) {
  props.forEach(prop => {
    this.$watch(prop, callback.bind(null, prop))
  })
}
